function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>Força e Inovação em Engenharia</h1>

          <p>Soluções completas em aço para indústria e construção</p>

          <a
            href="https://wa.me/5549999140597"
            className="btn"
            target="_blank"
            rel="noreferrer"
          >
            Solicitar orçamento
          </a>

          <div className="hero-features">
            <span>✔ Corte sob medida</span>
            <span>✔ Corte a laser de alta precisão</span>
            <span>✔ Dobras industriais</span>
            <span>✔ Perfis estruturais</span>
            <span>✔ Telhas metálicas</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
